import { ObservableArray, View } from "binder"
import { IForm, MenuEnabledStatusManipulationViewModel } from "./menuEnabledStatusManipulation-viewModel"

export class MenuEnabledStatusManipulationView extends View<MenuEnabledStatusManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-ACDDDC7E-61A8-43EB-A4B7-FDDB8DC5B30E"
    }
    loadHtml(): string {
        let element = require('./menuEnabledStatusManipulation.html').default;
        let style = require('./menuEnabledStatusManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set allForms(v: ObservableArray<IForm>) { this._allForms = v; } public get allForms(): ObservableArray<IForm> { return this._allForms;} private _allForms: ObservableArray<IForm>;

    save(){
        this.dataContext.save()
    }
    refresh(){
        this.dataContext.getAllForms();
    }
}
